<template>
  <!-- eslint-disable -->
  <v-app>
    <v-navigation-drawer class="mgmt-nav-drawer" fixed :mini-variant="miniVariant" :clipped="true" v-model="drawer" :touchless="true" app :width="navWidth" :mobile-break-point="60000">
      <v-list>
        <v-list-group class="main-nav-option" :class="'main-nav-option-' + isAllowedRole(item.roles)" v-model="item.active" v-for="item in items" :key="item.title" no-action v-show="isAllowedRole(item.roles)">
          <template v-slot:activator>
            <v-list-item-title>
              <v-icon>{{item.icon}}</v-icon>
              <span style="position: relative; top: 3px; left: 10px;">{{ item.title }}</span>
            </v-list-item-title>
          </template>
          <v-list-item sub-group style="padding-left: 35px;" class="child-nav-option" :class="['child-nav-option-' + isAllowedRole(subItem.roles), subItem.to]" v-show="isAllowedRole(subItem.roles)" v-for="subItem in item.children" :key="subItem.title" :to="{name:subItem.to}" :href="subItem.to"  >
            <v-list-item-title v-text="subItem.title" style="font-size: 14px;"></v-list-item-title>
            <v-list-item-action>
              <v-icon v-text="subItem.icon"></v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-list>
          <v-list-item>
            <v-btn class="logout-btn" style="margin: auto;" @click="logOut()" text>LogOut</v-btn>
          </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar fixed app class="mgmt-header" clipped-left style="z-index: 10">
      <v-app-bar-nav-icon class="mgmt-nav-toggle" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <img src="./assets/logo.png" height="25" width="25" /> ParcelShield
      </v-toolbar-title>
    </v-app-bar>
    <v-content v-if="groupsLoaded">
      <router-view></router-view>
    </v-content>
    <snack-bar class="api-error-bar" />
  </v-app>
<!-- eslint-enable -->
</template>

<script>
import { mapGetters } from "vuex";
import roles from "@/roles";
import { NAMESPACE } from "@/authentication/store/index";
import AllianceNav from "@/components/allianceDemo/nav";
import BillingNav from "@/components/billing/nav";
import CourierNav from "@/components/couriers/nav";
import UsersNav from "@/components/users/nav";
import ParcelShieldUsersNav from "@/components/parcelshieldusers/nav";
import FlightsNav from "@/components/flights/nav";
import PackagesNav from "@/components/packages/nav";
import CallsNav from "@/components/calls/nav";
import CalamityNav from "@/components/calamities/nav";
import PhoneNav from "@/components/phones/nav";
import TimeTrackingNav from "@/components/timetracking/nav";
import DeliverabilityNav from "@/components/deliverability/nav";
import QueueNav from "@/components/queue/nav";
import authentication from "@/authentication";
import SnackBar from "@/components/helpers/SnackBar";
export default {
  name: "MgmtApp",
  components: {
    "snack-bar": SnackBar
  },
  data() {
    return {
      drawer: false,
      navWidth: 275,
      fixed: false,
      items: [
        ...CalamityNav,
        ...CourierNav,
        ...UsersNav,
        ...BillingNav,
        ...PhoneNav,
        ...CallsNav,
        ...TimeTrackingNav,
        ...ParcelShieldUsersNav,
        ...FlightsNav,
        ...PackagesNav,
        ...DeliverabilityNav,
        ...QueueNav,
        ...AllianceNav
      ],
      miniVariant: false,
      groupsLoaded: false
    };
  },
  computed: {
    ...mapGetters(NAMESPACE, ["groups", "isAllowedRole"]),
    isAuthenticated() {
      return authentication.isAuthenticated();
    },
    profile() {
      return authentication;
    },
    token() {
      return authentication.getToken();
    },
    user() {
      return authentication.getUser();
    }
  },
  watch: {
    drawer: /* istanbul ignore next */ function(val) {
      this.$store.drawerOpen.open = val;
      this.$forceUpdate();
    }
  },
  created: /* istanbul ignore next */ function() {
    this.$store.drawerOpen = { open: this.drawer };
    this.$store.navWidth = this.navWidth;
    if (
      process.env.VUE_APP_RUN_AS_ADMIN == "true" &&
      process.env.NODE_ENV === "development"
    ) {
      var allGroups = [];
      for (let role in roles) allGroups.push({ id: roles[role] });
      var data = {
        allGroups: allGroups,
        userGroups: [{ id: roles.ADMIN }]
      };
      var testRoleName = window.location.hash.substring(1);
      if (roles[testRoleName]) data.userGroups = [{ id: roles[testRoleName] }];
      this.$store.commit(`${NAMESPACE}/SET_GROUPS`, data);
      this.groupsLoaded = true;
      return;
    }
    this.$store.dispatch(`${NAMESPACE}/GET_GROUPS`).then(() => {
      this.groupsLoaded = true;
    });
  },
  methods: {
    logOut() {
      authentication.signOut();
      // Used for e2e test
      this.$store.logout = true;
    }
  }
};
</script>
